export default Object.freeze({
    ALL_CATEGORIES: ['Service Alerts', 'Billing', 'Service', 'Organization'],
})
